import { Injectable } from "@angular/core";
import { HttpHeaders, HttpClient, HttpResponse } from "@angular/common/http";
import * as moment from "moment";

import { Order } from "../data/order";
import { Listing } from "../data/listing";

@Injectable()
export class OrderService {
  httpHeaders = new HttpHeaders({ "Content-Type": "application/json" });
  ordersUrl = "api/v2/orders";
  headers = { headers: this.httpHeaders };

  constructor(private httpClient: HttpClient) {}

  getOrders(
    orderId: number,
    from: Date,
    to: Date,
    limit: number
  ): Promise<Order[]> {
    return this.httpClient
      .get(
        `${this.ordersUrl}?orderId=${orderId || ""}&createdAtMin=${moment(
          from
        ).format()}&createdAtMax=${moment(
          to.getTime()
        ).format()}&limit=${limit}`
      )
      .toPromise()
      .then((response) => response as Order[])
      .catch(this.handleError);
  }
  getListingsForOrder(id: string): Promise<Listing[]> {
    return this.httpClient
      .get(`${this.ordersUrl}/${id}/listings`)
      .toPromise()
      .then((response) => response as Listing[])
      .catch(this.handleError);
  }
  handleError(error: any): Promise<any> {
    console.error("An error occurred", error);
    return Promise.reject(error.message || error);
  }
}
